import Money, { moneyFormat } from './Money';

export default Money;
export { moneyFormat };
